import * as constant from "../Constants";
import { BaseService } from "../Base";

export class Service extends BaseService {
  constructor() {
    super();
    this.configuration = {
      ...this.configuration,
      method: constant.BASE.method.post,
      resource: constant.BASE.resource.paypalAccounts
    };
    this.query = null;
  }
}
